declare var turnstile: any;

import { Component, AfterViewInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'captcha-cloudflare',
  template: `<div id="cf-turnstile" class="cf-turnstile"></div>`,
  styles: []
})
export class CaptchaCloudflareComponent implements AfterViewInit {

  @Input('size') size: string = 'normal'; //normal, invisible, compact
  @Input('theme') theme: string = 'light'; //dark
  @Input('key') key: string = '';
  @Output() captchaSuccess = new EventEmitter<string>();

  constructor(
    private elRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    this.loadCaptcha();
  }

  private loadCaptcha() {
    const turnstileScript = document.createElement('script');
    turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    turnstileScript.async = true;
    turnstileScript.defer = true;
    document.body.appendChild(turnstileScript);

    const config = {
      sitekey: this.key,
      callback: (token: string) => this.captchaSuccess.emit(token),
      'response-field': false, 
      theme: this.theme,
      size: this.size
    };    

    turnstileScript.onload = () => {
      turnstile.render(this.elRef.nativeElement.querySelector('#cf-turnstile'), config);
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/components/captcha-cloudflare/captcha-cloudflare.component.ts